export default __webpack_public_path__ + "static/media/Research1.784d2cb9.png";